import { useEffect, useRef } from "react";
import { FiHome } from "react-icons/fi";
import { classNames } from "./utils";

export default function FloatingAnchorBar({ sections, activeId, onClick }) {
  const scrollerRef = useRef(null);

  // Auto-centre le chip actif
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller || !activeId) return;
    const btn = scroller.querySelector(`[data-id="${activeId}"]`);
    if (!btn) return;
    const left = btn.offsetLeft - scroller.clientWidth / 2 + btn.clientWidth / 2;
    scroller.scrollTo({ left, behavior: "smooth" });
  }, [activeId]);

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[95vw] sm:w-auto">
      <div className="flex items-center gap-2 rounded-2xl border border-slate-200 dark:border-slate-800 bg-white/90 dark:bg-slate-900/90 backdrop-blur px-2 py-2 shadow-lg">
        <button
          onClick={() => onClick("intro")}
          className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded-xl text-sm border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
          aria-label="Aller à l'intro"
          title="Aller à l'intro"
        >
          <FiHome />
          Accueil
        </button>

        <div
          ref={scrollerRef}
          className="max-w-[82vw] sm:max-w-[60vw] overflow-x-auto no-scrollbar flex gap-2 px-1"
        >
          {sections.map((s) => (
            <button
              key={s.id}
              data-id={s.id}
              onClick={() => onClick(s.id)}
              className={classNames(
                "px-3 py-1.5 rounded-xl text-sm whitespace-nowrap border transition-colors",
                activeId === s.id
                  ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900 border-transparent"
                  : "border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
              )}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
